import { FACILITY_TYPES } from './types/facility';
const FacilityUtils = {
    ...FACILITY_TYPES,
    STATUSES: {
        DELETED: 'deleted',
        ARCHIVED: 'archived',
        OFF: 'off',
        OFF_ADMIN_VIEWABLE: 'off_admin_viewable',
        ON: 'on_sales_allowed',
        ON_SALES_NOT_ALLOWED: 'on_sales_not_allowed',
        ON_DIRECT_LINK_ONLY: 'on_direct_link_only',
    },
};
export default FacilityUtils;
